// © Microsoft Corporation. All rights reserved.

import { appEnvironment } from "@msnews/core";

export function getFlight(flightId): boolean {
    if (appEnvironment.CurrentRequestTargetScope && appEnvironment.CurrentRequestTargetScope.pageExperiments && flightId) {
        const experiments = appEnvironment.CurrentRequestTargetScope.pageExperiments;
        return !!experiments.find(x => x && x.toLowerCase() == flightId.toLowerCase());
    }
    return false;
}